import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-70c3a773"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "category-month"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 分享 ");
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "activity-entrance"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "entrance-box"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "popup-box"
};
const _hoisted_14 = {
  class: "info"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 0,
  class: "item-3"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
import { reactive, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from 'vuex';
import env from "md-base-tools/env";
import domain from "@/service/domain";
import { GoBack, wxMinaShare } from "../../utils/tools";
import ShareBox from "@@/common/ShareBox.vue";
export default {
  setup(__props) {
    const route = useRoute();
    const store = useStore();

    // 页面状态
    const state = reactive({
      is_ip: false,
      statusBarH: 10,
      showItem: 0,
      show: false
    });
    onMounted(() => {
      document.title = "游戏·潮玩品类月";
      state.is_ip = route.query.is_ip == 1 ? true : false;

      // 如果是APP端，设置状态栏颜色&获取设备信息
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "webNavColor",
          functionParams: {
            statusBarColorIsWhite: '1'
          }
        });

        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "onGetDeviceInfo",
          functionParams: {},
          callBack: e => {
            state.statusBarH = e.data.statusBarH;
          }
        });
      }
      // 微信小程序分享
      wxMinaShare({
        title: share_des,
        imageUrl: share_5x4,
        url: share_url
      });
    });
    const openInfo = item => {
      state.showItem = item;
      state.show = true;
    };
    const item42Box = ref(null);
    const item4Bg = ref(null);
    const item4Scroll = () => {
      if (item42Box.value.scrollTop > item42Box.value.scrollHeight - item42Box.value.clientHeight - 6) {
        item4Bg.value.style.opacity = 0;
      } else {
        item4Bg.value.style.opacity = 1;
      }
    };
    const isFix = ref(0);
    // 是否吸顶
    function handleStickyAction(is_fix) {
      isFix.value = is_fix ? 1 : 0;
    }

    // 离开页面
    function handleGoBack() {
      GoBack();
    }

    // 分享信息
    const share_1x1 = "https://p6.moimg.net/mdwxapp/category_month_202508/wx_share_icon.png?x-oss-process=image/resize,w_350,h_350,m_lfit/format,jpg/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1";
    const share_5x4 = "https://p6.moimg.net/mdwxapp/category_month_202508/mina_share_icon.png?x-oss-process=image/resize,w_600,h_480,m_lfit/format,jpg/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1";
    const share_des = '发布游戏·潮玩项目，即享流量+现金 双重狂补！';
    const share_url = `${domain.wap}/mdactivity/fastsell/category_month`;
    const shareInfo = {
      active_title: "",
      img: share_1x1,
      mina_app_name: "gh_7210ac3f1f08",
      mina_share_img: share_5x4,
      mina_share_path: 'pages/webviewPages/content/content?url=' + share_url,
      msg_des: share_des,
      qq_des: "",
      qq_share_url: share_url,
      qq_title: share_des,
      qr_img: share_1x1,
      qzone_share_url: share_url,
      share_url: share_url,
      sharelink_url: share_url,
      small_code: "",
      weibo_des: share_des + share_url,
      weibo_share_url: share_url,
      weibo_title: "",
      weixin_share_url: share_url,
      wxTimeline_share_url: share_url,
      wx_des: "",
      wx_title: share_des
    };

    // 分享
    function handleShareAction() {
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: 'openShareTool',
          functionParams: JSON.parse(JSON.stringify(shareInfo))
        });
      } else {
        triggerChangeShareStatus();
      }
    }

    // 调用 mutation 触发分享
    const triggerChangeShareStatus = () => {
      store.commit('currentShareUpdate', {
        obj: 'share_info',
        value: shareInfo
      });
      store.commit('changeShareStatus', {
        obj: 'showShare'
      });
    };

    // 去发起众筹项目
    function createProject() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `md://create_project`,
        webFun: () => {
          if (env.isWxApp()) {
            // eslint-disable-next-line no-undef
            wx.miniProgram.navigateTo({
              url: '/pages/projectPages/project-initiate/project-initiate'
            });
          } else {
            window.location.href = `${domain.account}/m/initiate`;
          }
        }
      });
    }

    // 去智能客服
    function goCustomerservice() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.account}/CustomerService/aiChat?scene=category_month`,
        webFun: () => {
          location.href = `${domain.account}/CustomerService/aiChat?scene=category_month`;
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_sticky = _resolveComponent("van-sticky");
      const _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_sticky, {
        onChange: handleStickyAction
      }, {
        default: _withCtx(() => [_createElementVNode("header", {
          class: _normalizeClass([{
            'headerAndroid': _unref(env).isModianAndroid()
          }]),
          style: _normalizeStyle({
            'padding-top': _unref(state).statusBarH + 'px'
          })
        }, [(_unref(env).isModianIos() || _unref(env).isModianIosNew() || _unref(env).isModianAndroid()) && !_unref(state).is_ip ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          class: _normalizeClass(["back-icon", {
            'isFix': isFix.value
          }]),
          "lazy-load": "",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/nav_back.png', 56),
          onClick: _withModifiers(handleGoBack, ["stop"])
        }, null, 8, ["class", "src", "onClick"])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: _normalizeClass(["share-info", {
            'isFix': isFix.value
          }]),
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleShareAction(), ["stop"]))
        }, [_createVNode(_component_van_image, {
          class: "icon",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/nav_share.png', 28)
        }, null, 8, ["src"]), _hoisted_2], 2)], 6)]),
        _: 1
      }), _createElementVNode("img", {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_01.png', 750)
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        class: "img",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_02.png', 750)
      }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item, index) => {
        return _createElementVNode("div", {
          class: "entrance-item",
          key: index,
          onClick: $event => openInfo(item)
        }, null, 8, _hoisted_7);
      }), 64))])]), _createElementVNode("img", {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_03.png', 750)
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_04.png', 750)
      }, null, 8, _hoisted_9), _createElementVNode("img", {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_05.png', 750)
      }, null, 8, _hoisted_10), _createElementVNode("img", {
        onClick: goCustomerservice,
        class: "customerservice",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_customerservice.png', 750)
      }, null, 8, _hoisted_11), _createElementVNode("div", {
        class: "bottom-btn-box",
        onClick: createProject
      }, [_createElementVNode("img", {
        class: "bottom-btn",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_btn.png', 686)
      }, null, 8, _hoisted_12)]), _createVNode(_component_van_overlay, {
        show: _unref(state).show,
        "lock-scroll": _unref(state).showItem == 3 ? false : true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
          class: "close",
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => _unref(state).show = false, ["stop"])),
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/md/icon/close.png', 56)
        }, null, 8, _hoisted_15), _unref(state).showItem == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("img", {
          class: "item-3-1",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_popup_3_1.png', 686)
        }, null, 8, _hoisted_17), _createElementVNode("div", {
          class: "item-3-2-box",
          ref_key: "item42Box",
          ref: item42Box,
          onScroll: item4Scroll
        }, [_createElementVNode("img", {
          class: "item-3-2",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_popup_3_2.png', 686)
        }, null, 8, _hoisted_18)], 544), _createElementVNode("div", {
          class: "item-3-bg",
          ref_key: "item4Bg",
          ref: item4Bg
        }, null, 512)])) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: _normalizeClass(`item-${_unref(state).showItem}`),
          src: _ctx.$imgUrlFilter(`https://p6.moimg.net/mdwxapp/category_month_202508/category_month_popup_${_unref(state).showItem}.png`, 686)
        }, null, 10, _hoisted_19))])])]),
        _: 1
      }, 8, ["show", "lock-scroll"])]), _createVNode(ShareBox)], 64);
    };
  }
};